import axios from "axios";

// Calls our own serverless function (netlify/functions/defi.mjs) rather than
// DefiLlama directly. DefiLlama does send CORS headers, so the browser could
// call it - the reason not to is size. The two upstream documents the page
// needs are 8.9 MB and about 850 KB per protocol; the function reshapes them
// into a few kB and one refresh serves every visitor through the durable cache.
//
// Returns null rather than an empty shape when the data cannot be had, for the
// same reason getWatchlistApi does: null is "we still don't know" and should
// leave whatever is on screen alone, where an empty object is "there is nothing"
// and would blank the page.
export const getDefiApi = async () => {
  try {
    const response = await axios.get("/api/defi");
    const data = response.data;

    if (!data || !Array.isArray(data.custody) || !Array.isArray(data.chains)) {
      console.error("Unexpected defi response:", data);
      return null;
    }

    return data;
  } catch (error) {
    console.error("DeFi fetch failed:", error);
    return null;
  }
};
